/* CAST collection-card colour swatches: swap the card image and links to the chosen colour. */
(function () {
  if (window.castCardSwatchesBound) return;
  window.castCardSwatchesBound = true;

  function preload(btn) {
    if (btn.dataset.pre || !btn.dataset.src) return;
    btn.dataset.pre = '1';
    var i = new Image();
    if (btn.dataset.srcset) { i.sizes = '(min-width: 990px) 25vw, 50vw'; i.srcset = btn.dataset.srcset; }
    i.src = btn.dataset.src;
  }

  function choose(btn) {
    var card = btn.closest('.card-wrapper');
    if (!card) return;
    Array.prototype.forEach.call(card.querySelectorAll('.cast-sw__btn'), function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    var img = card.querySelector('.card__media .media > img');
    if (img && btn.dataset.src) {
      var next = new Image();
      img.classList.add('cast-sw-loading');
      var done = function () { img.classList.remove('cast-sw-loading'); };
      next.onload = next.onerror = done;
      if (btn.dataset.srcset) { next.sizes = img.sizes || '50vw'; next.srcset = btn.dataset.srcset; }
      next.src = btn.dataset.src;
      if (btn.dataset.srcset) img.srcset = btn.dataset.srcset; else img.removeAttribute('srcset');
      img.src = btn.dataset.src;
      img.removeAttribute('loading');
      var label = btn.getAttribute('title');
      if (label) img.alt = (card.querySelector('.card__heading a') || {}).textContent ? card.querySelector('.card__heading a').textContent.trim() + ', ' + label : label;
      if (img.complete) done();
      card.classList.add('cast-sw-on');
    }
    var url = btn.dataset.url;
    if (url) {
      Array.prototype.forEach.call(card.querySelectorAll('.card__heading a[href]'), function (a) { a.href = url; });
      Array.prototype.forEach.call(card.querySelectorAll('.quick-add__submit[data-product-url]'), function (q) { q.setAttribute('data-product-url', url); });
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cast-sw__btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    choose(btn);
  }, true);
  ['mouseover', 'focusin', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var btn = e.target.closest && e.target.closest('.cast-sw__btn');
      if (btn) preload(btn);
    }, { passive: true, capture: true });
  });
})();
